const CAR_IMAGE_DISCLAIMER =
  "All images are for illustration purposes only. Where a dealer has not supplied an image for the specific car, an image from a similar vehicle will be shown.";

export default CAR_IMAGE_DISCLAIMER;